import { signInWithCustomToken } from "firebase/auth";
import { auth, getAppCheckToken } from "@/service/firebase";
import { FUNCTIONS_URL } from "../constants/keys";

export async function autenticarPorCode(code) {
  const appCheckToken = await getAppCheckToken();

  const headers = { "Content-Type": "application/json" };
  if (appCheckToken) {
    headers["X-Firebase-AppCheck"] = appCheckToken;
  }

  // 1. Chama a Cloud Function pública com o token App Check
  const response = await fetch(
    `${FUNCTIONS_URL}autenticarPorCode`,
    {
      method: "POST",
      headers,
      body: JSON.stringify({ code }),
    }
  );

  if (!response.ok) {
    const err = await response.json();
    // Repassa o erro pra tratar no componente
    throw { status: response.status, ...err };
  }

  const { token: customToken } = await response.json();

  // 2. Firebase troca o Custom Token por um ID Token e estabelece sessão
  const userCredential = await signInWithCustomToken(auth, customToken);

  // 3. Retorna o compra_id que já está no claim do token
  const idToken = await userCredential.user.getIdTokenResult();
  return {
    compra_id: idToken.claims.compra_id,
  };
}

// Chamada best-effort: sinaliza ao backend que o upload concluiu.
// Marca o code como usado e remove o Auth user de sessão.
export async function marcarCodeUsado() {
  const user = auth.currentUser;
  if (!user) return;
  const idToken = await user.getIdToken();
  await fetch(`${FUNCTIONS_URL}marcarCodeUsado`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({}),
  });
}